export default __webpack_public_path__ + "static/media/man_in_the_wind_12.460b7471.png";